import { render, staticRenderFns } from "./dupDev.vue?vue&type=template&id=15fc68d7"
import script from "./dupDev.vue?vue&type=script&lang=js"
export * from "./dupDev.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports